import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import momencik from '../../../common/momencik';
import { GetVisitRegistrationDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface ExternalVisitBookingSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  withFilterInColumns?: boolean;
}

export const externalVisitBookingForGrid = (visit: GetVisitRegistrationDto) => {
  return {
    key: visit.id,
    values: {
      'visitRegistration.visitDateTime':
        momencik(visit.visitDateTime, 'YYYY-MM-DD HH:mm') || '',
      'visitRegistration.visitTime': visit.visitTime
        ? `${visit.visitTime} min`
        : '',
      'visitRegistration.surname': visit.surname || '',
      'visitRegistration.firstname': visit.firstname || '',
      'visitRegistration.mail': visit.mail || '',
      'visitRegistration.phone': visit.phone || '',
      'healthcareFacility.displayName':
        visit.appointmentChannel?.healthcareFacility?.displayName || '',
      'examType.name': visit.examType?.name || '',
      'exam.id': visit.exam ? 'Tak' : 'Nie',
    },
  };
};

export const ExternalVisitBookingSearch: React.FC<
  ExternalVisitBookingSearchProps
> = props => {
  const columns = [
    { header: 'Data i godzina', property: 'visitRegistration.visitDateTime' },
    { header: 'Nazwisko', property: 'visitRegistration.surname' },
    { header: 'Imię', property: 'visitRegistration.firstname' },
    { header: 'E-mail', property: 'visitRegistration.mail' },
    { header: 'Telefon', property: 'visitRegistration.phone' },
    { header: 'Placówka', property: 'healthcareFacility.displayName' },
    { header: 'Czas', property: 'visitRegistration.visitTime' },
    { header: 'Typ badania', property: 'examType.name' },
    {
      header: 'Utworzono badanie',
      property: 'exam.id',
      noSorting: false,
      noFilter: true,
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      withFilterInColumns={props.withFilterInColumns}
      withHistory={true}
      initialOrderColumn="visitRegistration.visitDateTime"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      onRowClick={props.onRowClick}
      emptyGridMessage="Brak zapisów"
      refresh={props.refresh}
    />
  );
};
